import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';

/**
 * Lit le cookie rh_inventory (staff WMS identifié) de façon fiable, y compris lors d'une
 * déconnexion faite depuis un autre onglet.
 * react-cookie ne notifie un changement que s'il est fait depuis le même onglet ; on complète donc
 * la relecture directe de document.cookie à chaque rendu par un rafraîchissement forcé au retour de
 * focus sur l'onglet, seul moment où une modification faite ailleurs peut être détectée.
 */
const useRhInventoryCookie = () => {
    //Sert uniquement de déclencheur de re-render : se met à jour dès qu'un set/remove du cookie est fait dans cet onglet
    useCookies(['rh_inventory']);

    //Force un nouveau rendu dès qu'on revient sur cet onglet, pour détecter un changement fait depuis un autre onglet
    const [,forceRefresh] = useState(0);
    useEffect(function () {
        const syncOnFocus = () => forceRefresh(tick => tick + 1);
        window.addEventListener('focus', syncOnFocus);
        document.addEventListener('visibilitychange', syncOnFocus);
        return () => {
            window.removeEventListener('focus', syncOnFocus);
            document.removeEventListener('visibilitychange', syncOnFocus);
        };
    }, []);

    //react-cookie encode la valeur (ex: les virgules deviennent %2C) : sans décodage, le split(',') en aval
    //ne trouve plus aucune virgule et ampute le nom/prénom du staff
    const rawValue = document.cookie.replace(/(?:(?:^|.*;\s*)rh_inventory\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    return rawValue ? decodeURIComponent(rawValue) : undefined;
};

export default useRhInventoryCookie;
